import React from 'react';
import { Row, Typography, theme } from 'antd';
import { getZoneStyle, type ControlTowerZone } from './controlTowerTheme';

const { Text } = Typography;

export interface ControlTowerMetricStripProps {
  zone: ControlTowerZone;
  title: string;
  children: React.ReactNode;
}

export const ControlTowerMetricStrip: React.FC<ControlTowerMetricStripProps> = ({ zone, title, children }) => {
  const { token } = theme.useToken();
  const zoneStyle = getZoneStyle(token, zone);

  return (
    <div style={{ ...zoneStyle.stripStyle, marginBottom: 0 }}>
      <Text strong style={{ display: 'block', marginBottom: 12 }}>
        {title}
      </Text>
      <Row gutter={[16, 16]}>{children}</Row>
    </div>
  );
};
